import * as BrowserHistoryUtils from './utils/browser-history-utils';
import * as FormValidationUtils from './utils/form-validation-utils';
import ContentToggle from './modules/content-toggle';
import DesktopNavMenus from './modules/desktop-nav-menus';
import Lazyload from './modules/lazyload';
import MobileNav from './modules/mobile-nav';
import TabRole from './modules/accessibility/tab-role';
import Timeline from './modules/timeline';
import Glide from './vendors/glide.min';

window.BrowserHistoryUtils = BrowserHistoryUtils;
window.FormValidationUtils = FormValidationUtils;

ContentToggle();
DesktopNavMenus();
Lazyload();
MobileNav();
TabRole();
Timeline();

if (document.querySelector('.contact-us-form')) {
  const contactReason = document.getElementById('Subject');
  const shippingAddress = document.querySelector('.shipping-address');
  const zipCode = document.querySelector('.zip-code');
  const cityState = document.querySelector('.city-state');
  const orderNumber = document.querySelector('.order-number');
  const purchaseDate = document.querySelector('.purchase-date');
  const productSize = document.querySelector('.product-size');
  const orderMessage = document.querySelector('.order-info-message');

  contactReason.addEventListener('change', () => {
    if (contactReason.value === 'Parts, Repairs, Warranty') {
      shippingAddress.classList.remove('hide');
      zipCode.classList.remove('hide');
      cityState.classList.remove('hide');
      orderNumber.classList.remove('hide');
      purchaseDate.classList.remove('hide');
      productSize.classList.remove('hide');
      orderMessage.classList.remove('hide');
    } else {
      shippingAddress.classList.add('hide');
      zipCode.classList.add('hide');
      cityState.classList.add('hide');
      orderNumber.classList.add('hide');
      purchaseDate.classList.add('hide');
      productSize.classList.add('hide');
      orderMessage.classList.add('hide');
    }
  });
}
// Career Growth Stories Slider
/* eslint-disable no-use-before-define */
const tabs = document.querySelectorAll('#tab-slider .glide__slides li');
if (tabs.length > 1) {
  const careerSlider = new Glide('.glide', {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    gap: 0,
  });
  careerSlider.on('move.after', () => {
    setTimeout(() => GetActiveElHeight(slides), 200);
  });
  careerSlider.on('swipe.after', () => {
    setTimeout(() => GetActiveElHeight(slides), 400);
  });
  careerSlider.on('resize', () => {
    GetActiveElHeight(slides);
  });
  careerSlider.on('build.after', () => {
    setTimeout(() => GetActiveElHeight(slides), 200);
  });
  careerSlider.mount();
}
const slides = document.querySelectorAll('.glide__slides li');
function GetActiveElHeight(els) {
  let activeHeight = 0;
  // console.log(els);
  els.forEach((el) => {
    if (el.classList.contains('glide__slide--active')) {
      const container = el.querySelector('.container').clientHeight;
      const careerEvent = el.querySelector('.career-events').clientHeight;
      activeHeight = container + careerEvent;
    }
  });
  els.forEach((el) => {
    const inner = el.querySelector('.glide__slide--inner');
    inner.style.height = `${activeHeight}px`;
  });
}
